import Model from "@/models/Model"

export default class AAvailableBranchOffices extends Model {
    resource() {
        return "available_branch_offices"
    }
}